const STORAGE_KEY = 'postLoginPath'
const DEFAULT_PATH = '/dashboard'

/** Remembers an in-app path (e.g. an invite link) to open after the user signs in */
export function rememberPostLoginPath(path: string) {
  try {
    sessionStorage.setItem(STORAGE_KEY, path)
  } catch {
    // Storage blocked: the user just lands on the dashboard
  }
}

// Login can resolve the redirect twice (form callback + auth state effect);
// keep the consumed path briefly so both get the same answer
let recentlyConsumed: string | null = null

/** Returns (and forgets) the remembered path; only internal dashboard paths are allowed */
export function consumePostLoginPath(): string {
  if (recentlyConsumed) return recentlyConsumed
  try {
    const path = sessionStorage.getItem(STORAGE_KEY)
    sessionStorage.removeItem(STORAGE_KEY)
    if (path?.startsWith('/dashboard') && !path.startsWith('//')) {
      recentlyConsumed = path
      setTimeout(() => {
        recentlyConsumed = null
      }, 5000)
      return path
    }
  } catch {
    // ignore
  }
  return DEFAULT_PATH
}
